var React = require('react');

function TrackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.666748 23.6524L10.6667 13.639L16.0001 18.9724L25.4534 8.3457L27.3334 10.2257L16.0001 22.9724L10.6667 17.639L2.66675 25.6524L0.666748 23.6524ZM2.66675 17.6524L10.6667 9.63904L16.0001 14.9724L27.3334 2.2257L25.4534 0.345703L16.0001 10.9724L10.6667 5.63904L0.666748 15.6524L2.66675 17.6524Z","fill":"#1B2B4C"}));
}

TrackInline.defaultProps = {"width":"28","height":"26","viewBox":"0 0 28 26","fill":"none"};

module.exports = TrackInline;

TrackInline.default = TrackInline;
